import { useContext } from "react";
import styles from "./PortalSidebar.module.scss";
import { NavLink } from "react-router-dom";
import { UserDetailsContext } from "../../contexts/UserDetailsProvider";
import { Tooltip } from "@mui/material";

const PortalSidebar = () => {
  const current_url = window.location.pathname;
  const { noCompany } = useContext(UserDetailsContext);
  return (
    <>
      <div className={styles["sidebar-container"]}>
        <ul className={styles["sidebar-items"]}>
          {sidebarMenu.map((item, index) => {
            const isDisabled =
              noCompany &&
              ["Bids", "Live Bids", "Companies", "Messages", "Team"].includes(
                item.title
              );

            const navItem = (
              <NavLink
                to={isDisabled ? "#" : item.path}
                key={index}
                className={
                  current_url.includes(item.title.toLowerCase()) ||
                  current_url === item.path
                    ? `${styles["item-link"]} ${
                        isDisabled ? styles["disabled"] : styles["active"]
                      }`
                    : `${styles["item-link"]} ${
                        isDisabled ? styles["disabled"] : ""
                      }`
                }
                onClick={(e) => {
                  if (isDisabled) e.preventDefault();
                }}
              >
                <li className={styles["sidebar-item"]}>
                  <img
                    className={styles["item-icon"]}
                    src={item.icon}
                    alt={item.title}
                  />
                  <span className={styles["item-name"]}>{item.title}</span>
                </li>
              </NavLink>
            );

            return isDisabled ? (
              <Tooltip
                key={index}
                title="Please register your company first"
                placement="right"
                arrow
              >
                <span>{navItem}</span>
              </Tooltip>
            ) : (
              navItem
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default PortalSidebar;

const sidebarMenu = [
  {
    icon: "/images/portal/layout/icons/dashboard-icon.svg",
    title: "Dashboard",
    path: "/portal",
  },
  {
    icon: "/images/portal/layout/icons/bid-list-icon.svg",
    title: "Bids",
    path: "/portal/bids",
  },
  {
    icon: "/images/portal/layout/icons/live.svg",
    title: "Live Bids",
    path: "/portal/liveBids",
  },
  {
    icon: "/images/portal/layout/icons/building.svg",
    title: "Companies",
    path: "/portal/companies",
  },
  {
    icon: "/images/portal/layout/icons/icons8-message.svg",
    title: "Messages",
    path: "/portal/messages",
  },
  {
    icon: "/images/portal/layout/icons/teams-2.svg",
    title: "Team",
    path: "/portal/teams",
  },
  {
    icon: "/images/portal/layout/icons/support.svg",
    title: "Support",
    path: "/portal/support",
  },
];
